import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequestWithParams } from "../../services/API";
import { isEmpty } from "../../services/validation";
import { strings } from "../../utils/constants/strings";
import axios from "axios";
import { getToken } from "../../services/API";
import { Toast } from "../../component/Toast";

const FETCH_ADA_REQUESTS = "fetchAdaRequestsAction";

export const fetchAdaRequestsAction = createAsyncThunk(
  FETCH_ADA_REQUESTS,
  async (requestInfo, { rejectWithValue }) => {
    let requestUrl =
      "?page=" + requestInfo.page + "&limit=" + requestInfo.limit + "&order=desc";

    try {
      if (!isEmpty(requestInfo.searchText)) {
        requestUrl = requestUrl + "&search_key=" + requestInfo.searchText;
      }

      if (!isEmpty(requestInfo.carrierId)) {
        requestUrl = requestUrl + "&carrier_id=" + requestInfo.carrierId;
      }

      if (!isEmpty(requestInfo.privacyServiceId)) {
        requestUrl = requestUrl + "&policy_service_id=" + requestInfo.privacyServiceId;
      }

      let result = await getRequestWithParams(
        requestInfo.language,
        "formAdaRequests",
        requestUrl,
        true
      );
      return result;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);

const DISCARD_ADA_REQUEST = "discardAdaRequestAction";

export const discardAdaRequestAction = createAsyncThunk(
  DISCARD_ADA_REQUEST,
  async ({ language, formId }, { rejectWithValue }) => {
    try {
      const token = getToken(true);
      const url = `${process.env.REACT_APP_API_ENDPOINT}/${language}/form/${formId}/discard-ada-request`;
      const { data } = await axios.patch(url, null, {
        headers: { Authorization: `Bearer ${token}` },
      });
      Toast({ type: "success", title: strings.words.SUCCESS, message: data.message });
      return data;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      Toast({ type: "error", title: strings.words.ERROR, message });
      return rejectWithValue({ message });
    }
  }
);
